export const urls = {
  fetchTraderStrategies: ({ userId }) => `/api/v1/trader/strategies?userId=${userId}`,
  fetchTraderStrategyInfo: ({ strategyId, userId }) => `/api/v1/trader/strategy/${strategyId}?userId=${userId}`,
  fetchTradersActiveCalls: ({ strategyId, userId }) =>
    `/api/v1/trader/strategy/${strategyId}/active-calls?userId=${userId}`,
  fetchTradersPastCalls: ({ strategyId, userId, page, size, fromTime = '', toTime = '' }) =>
    `/api/v1/trader/strategy/${strategyId}/past-calls?userId=${userId}&page=${page}&size=${size}&fromTime=${fromTime}&toTime=${toTime}`,
};
